export const appName = "PAPIO";
export const appTagline = "Talking Transcribed";
export const defaultImage =
  "https://res.cloudinary.com/dx6f6g5cv/image/upload/v1552365904/simple_vsrfm4.jpg";
